import React from 'react';
import Autosuggest from 'react-autosuggest';
import { Icon } from 'ui';

// Must pass in the following props:
//  - placeholder
//  - searchables (must be an array)
//  - searchableProperty
//  - defaultSearchableProperty (what will suggestions without names or titles be called?)
//  - selectionCallback (this will be a function)

// Optional props:
//  - iconMappings (for example, iconMappings={{ 'Info': 'info' }})
//  - iconProperty= "type"

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestions: [],
    };
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onSuggestionsFetchRequested =
      this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested =
      this.onSuggestionsClearRequested.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  filterSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.props.searchables.filter(searchable =>
          (
            searchable[this.props.searchableProperty] ||
            this.props.defaultSearchableProperty
          )
            .toLowerCase()
            .includes(inputValue.toLowerCase()),
        );
  }

  onChange(event, { newValue }) {
    this.setState({
      value: newValue,
    });
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.filterSuggestions(value),
    });
  }

  getSuggestionValue(suggestion) {
    return suggestion[this.props.searchableProperty];
  }

  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
      value: '',
    });
  }

  onSuggestionSelected(e, { suggestion }) {
    this.props.selectionCallback(suggestion);
    this.setState({ value: '' });
  }

  renderSuggestion(suggestion) {
    const iconName =
      this.props.iconProperty &&
      this.props.iconMappings[suggestion[this.props.iconProperty]];
    return (
      <div>
        {iconName && (
          <span>
            <Icon name={iconName} className="mr-4" />
          </span>
        )}
        {suggestion[this.props.searchableProperty]}
      </div>
    );
  }

  onKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  render() {
    const inputProps = {
      value: this.state.value,
      onChange: this.onChange,
      placeholder: this.props.placeholder,
      onKeyDown: this.onKeyDown,
    };

    return (
      <Autosuggest
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        focusFirstSuggestion
      />
    );
  }
}

export default AutoComplete;
